import React, { useEffect, useState } from "react";
import ServiceProviders from "../../public/sidebar/service-providers.svg";
import axios from "axios";

import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { approveProvider, getUserVerificationData } from "../../utils/apis/func";
import NinReuseNotice from "../../components/NinReuseNotice";
import Loader from "../../components/Loader";
import GoBack from "../../components/GoBack";
import { Dialog, DialogBody } from "@material-tailwind/react";
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";
import TextEditor from "../../components/TextEditor";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../../components/Carousel";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../components/Tabs";

export default function Verificationprofile() {
  const [viewProviderInReview, setProvider] = useState<any>(null);
  const query = useParams();
  const [identityRecord, setIdentityRecord] = useState<any>(null);
  const [profileError, setProfileError] = useState('');
  const [profileLoading, setProfileLoading] = useState(true);
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    const refresh = () => setRevision(value => value + 1);
    window.addEventListener('focus', refresh);
    return () => window.removeEventListener('focus', refresh);
  }, []);
  useEffect(() => {
    let active = true;
    setProvider(null); setIdentityRecord(null); setProfileError(''); setProfileLoading(true);
    Promise.all([
      axios.get(`${process.env.REACT_APP_BASE_URL || 'https://api.pureworker.com/api'}/provider/get-profile/${encodeURIComponent(query.id || '')}`, {withCredentials: true, timeout: 25000}),
      getUserVerificationData(query.id || ''),
    ]).then(([profile, identity]) => {
      if (!active) return;
      const row = profile.data?.profile;
      if (String(row?._id || row?.id) !== query.id) throw new Error('Provider mismatch');
      setProvider(row); setIdentityRecord(identity.data?.data);
    }).catch(() => {if (active) setProfileError('Could not load this provider and ID status. Please retry.');})
      .finally(() => {if (active) setProfileLoading(false);});
    return () => {active = false;};
  }, [query.id, revision]);

  const [loading, setloading] = useState(false);

  const navigate = useNavigate();
  const [reason, setReason] = useState<string>("");

  const handleApprove = async (status: any) => {
    if (loading || !viewProviderInReview || String(viewProviderInReview._id || viewProviderInReview.id) !== query.id) return;
    try {
      setloading(true);
      const res: any = await approveProvider({
        status: status,
        reason: reason,
        id: query.id,
      });
      if (res?.status === 200 || res?.status === 201) {
        toast(res.data?.message || "Update Successful", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        if (Array.isArray(res.data?.notificationWarnings) && res.data.notificationWarnings.length) {
          toast.warn(`The profile decision was saved. ${res.data.notificationWarnings.join(' ')}`, {autoClose: 10000});
        }
        setOpen(false);
        navigate("/verification");
      } else {toast.error(res?.error?.message || "Could not update this provider. Refresh and try again.");}
    } catch (error) {
      // Handle login error
      toast.error("Could not update this provider. Refresh and try again.");
    } finally {
      setloading(false);
    }
  };
  const profilePicSource: any = viewProviderInReview?.profilePic
    ? { uri: viewProviderInReview.profilePic }
    : ServiceProviders;

  const handleNavigate = () => {
    if (identityRecord?._id) window.open(`/id-check/${identityRecord._id}/verify-nin`, '_blank', 'noopener,noreferrer');
    else toast.info('No ID submission is available.');
  };
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(!open);

  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default behavior (submitting form)
      setReason((prevReason) => prevReason + "\n"); // Append new line character
    }
  };

  const handleChange = (e: any) => {
    setReason(e.target.value);
  };


  const [fullImg, setFullImg] = useState(false);
  const handleFullImg = () => setFullImg(!fullImg);

  const [selecetedImage, setSelectedImg] = useState<string>();
  const handleSelected = (image: string) => setSelectedImg(image);

  const [editorState, setEditorState] = useState();

  const onEditorStateChange = (newState: any) => {
    setEditorState(newState);
  };

  //  const handleGetEditorValue = () => {
  //   const contentState = editorState.getCurrentContent();
  //   const rawContentState = convertToRaw(contentState);
  //   console.log("Editor value:", JSON.stringify(rawContentState));
  // };

  const [model, setModel] = useState("");

  if (profileLoading) return <Loader />;
  if (profileError) return <div role="alert" className="p-6">{profileError} <button onClick={() => setRevision(value => value + 1)}>Retry</button></div>;
  return (
    <>
      <div className="">
        <div className="px-3 flex gap-6 items-baseline">
          <GoBack />
          <p className="text-[#000] font-roboto text-2xl font-medium leading-normal mt-4 border-b-2 border-[#000] w-fit px-4">
            Verification
          </p>
        </div>
        <main className="px-4">
          <div className="mx-auto flex flex-row items-center  w-3/4 justify-center mt-4">
            <img
              onClick={() => {
                handleSelected(
                  viewProviderInReview?.profilePic || ServiceProviders
                );
                setFullImg(true);
              }}
              src={viewProviderInReview?.profilePic || ServiceProviders}
              alt="Providers"
              className="w-[125px] h-[125px] rounded-full"
            />
            <p className="text-[#000] font-roboto text-[16px] font-medium leading-normal mt-4 border-[#000]  px-4">
              {viewProviderInReview?.description}
            </p>
          </div>

          <div className="mx-auto flex flex-row  w-full justify-between mt-4">
            <div className="w-1/3 flex flex-col mx-auto  items-start pl-[10%]">
              <p className="text-[#000]  font-roboto text-lg font-medium leading-normal mt-4 border-[#000]  px-4">
                Basic Information
              </p>
              <p className="text-[#636363]  font-roboto text-[12px] font-medium leading-normal mt-4 border-[#000]  px-4">
                Information provided on registration
              </p>
            </div>

            <div className="flex flex-col flex-1 ">
              <div className="flex flex-row w-full justify-between">
                <div className="w-1/3 ">
                  <p className="text-[#606060]  font-roboto text-[16px] font-medium leading-normal mt-4 border-[#000]  px-4">
                    FirstName
                  </p>
                  <p className="text-[#000] font-roboto text-[16px] font-medium leading-normal mt-2 border-[#000]  px-4">
                    {viewProviderInReview?.businessName
                      ? viewProviderInReview?.businessName
                      : `${viewProviderInReview?.firstName}`}
                  </p>
                </div>

                <div className="w-1/3 ">
                  <p className="text-[#606060]  font-roboto text-[16px] font-medium leading-normal mt-4 border-[#000]  px-4">
                    LastName
                  </p>
                  <p className="text-[#000] font-roboto text-[16px] font-medium leading-normal mt-2 border-[#000]  px-4">
                    {viewProviderInReview?.lastName
                      ? viewProviderInReview?.lastName
                      : ""}
                  </p>
                </div>

                <div className="w-1/3 ">
                  <p className="text-[#606060]  font-roboto text-[16px] font-medium leading-normal mt-4 border-[#000]  px-4">
                    Phone Number
                  </p>
                  <p className="text-[#000] font-roboto text-[16px] font-medium leading-normal mt-2 border-[#000]  px-4">
                    {viewProviderInReview?.phoneNumber}
                  </p>
                </div>
              </div>
              <div className="flex flex-row w-full mt-6 justify-between">
                <div className="w-1/3 ">
                  <p className="text-[#606060]  font-roboto text-[16px] font-medium leading-normal mt-4 border-[#000]  px-4">
                    Email Address
                  </p>
                  <p className="text-[#000] font-roboto text-[16px] font-medium leading-normal mt-2 border-[#000]  px-4">
                    {viewProviderInReview?.email}
                  </p>
                </div>

                <div className="w-1/3 ">
                  <p className="text-[#606060]  font-roboto text-[16px] font-medium leading-normal mt-4 border-[#000]  px-4">
                    Date of Birth
                  </p>
                  <p className="text-[#000] font-roboto text-[16px] font-medium leading-normal mt-2 border-[#000]  px-4">
                    {viewProviderInReview?.dob || "none"}
                  </p>
                </div>
              </div>
              <div className="flex flex-row w-full mt-6 justify-between">
                <div className="w-1/3 ">
                  <p className="text-[#606060]  font-roboto text-[16px] font-medium leading-normal mt-4 border-[#000]  px-4">
                    Addressess
                  </p>
                  <p className="text-[#000] font-roboto text-[16px] font-medium leading-normal mt-2 border-[#000]  px-4">
                    {viewProviderInReview?.address}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="mx-auto flex flex-row  w-full justify-between mt-8 border-t">
            <div className="w-1/3 flex flex-col mx-auto  items-start pl-[10%]">
              <p className="text-[#000]  font-roboto text-lg font-medium leading-normal mt-4 border-[#000]  px-4">
                Services
              </p>
              <p className="text-[#000]  font-roboto text-[12px] font-medium leading-normal mt-4 border-[#000]  px-4">
                What services is provided
              </p>
            </div>

            <div className="flex flex-col flex-1 ">
              {viewProviderInReview?.services?.map((item: any, index: any) => {
                const pd = viewProviderInReview?.portfolios?.filter(
                  (ser: any) => ser?.service === item?._id
                );
                // console.log("pd--", pd);
                return (
                  <div
                    key={index}
                    className="flex flex-row w-full justify-between"
                  >
                    <div className="w-1/3 ">
                      <p className="text-[#606060]  font-roboto text-[13px] font-medium leading-normal mt-4 border-[#000]  px-4">
                        Service
                      </p>
                      <p className="text-[#000] font-roboto text-[16px] font-medium leading-normal mt-2 border-[#000]  px-4">
                        {item?.name ? item?.name : ""}
                      </p>
                    </div>

                    <div className="w-1/3 ">
                      <p className="text-[#606060]  font-roboto text-[13px] font-medium leading-normal mt-4 border-[#000]  px-4">
                        Description
                      </p>
                      <p className="text-[#000] font-roboto text-[16px] font-medium leading-normal mt-2 border-[#000]  px-4">
                        {pd?.[0]?.description ? pd?.[0]?.description : ""}
                      </p>
                    </div>

                    <div className="w-1/3 ">
                      <p className="text-[#606060]  font-roboto text-[13px] font-medium leading-normal mt-4 border-[#000]  px-4">
                        Price Range
                      </p>
                      <p className="text-[#000] font-roboto text-[16px] font-medium leading-normal mt-2 border-[#000]  px-4">
                        ₦ {pd?.[0]?.minPrice ? pd?.[0]?.minPrice : ""} -{" "}
                        {pd?.[0]?.maxPrice ? pd?.[0]?.maxPrice : ""}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="mx-auto flex flex-row  w-full justify-between mt-8 border-t">
            <div className="w-1/3 flex flex-col mx-auto  items-start pl-[10%]">
              <p className="text-[#000]  font-roboto text-lg font-medium leading-normal mt-4 border-[#000]  px-4">
                City
              </p>
              <p className="text-[#000]  font-roboto text-[12px] font-medium leading-normal mt-4 border-[#000]  px-4">
                Cities there are available in
              </p>
            </div>
            <div className="flex flex-col flex-1 ">
              <div className="flex flex-row w-full justify-between">
                <div className="w-1/3 ">
                  <p className="text-[#606060]  font-roboto text-[13px] font-medium leading-normal mt-4 border-[#000]  px-4">
                    City
                  </p>
                  <p className="text-[#000] font-roboto text-[16px] font-medium leading-normal mt-2 border-[#000]  px-4">
                    {""}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="mx-auto flex flex-row  w-full justify-between mt-8 border-t">
            <div className="w-1/3 flex flex-col mx-auto  items-start pl-[10%]">
              <p className="text-[#000]  font-roboto text-lg font-medium leading-normal mt-4 border-[#000]  px-4">
                Portfolio
              </p>
              <p className="text-[#000]  font-roboto text-[12px] font-medium leading-normal mt-4 border-[#000]  px-4">
                Project service provide as worked on
              </p>
            </div>

            <div className="flex flex-col flex-1 mt-4">
              <Tabs
                defaultValue={viewProviderInReview?.portfolios?.[0]?.service}
                className=""
              >
                <TabsList>
                  {viewProviderInReview?.portfolios?.map((portfolio: any) => (
                    <TabsTrigger value={portfolio?.service}>
                      {
                        viewProviderInReview?.services?.find(
                          (service: any) => service?._id === portfolio?.service
                        )?.name
                      }
                    </TabsTrigger>
                  ))}
                </TabsList>
                {viewProviderInReview?.portfolios?.map((portfolio: any) => (
                  <TabsContent value={portfolio?.service}>
                    {portfolio.portfolio?.map((item: any, index: any) => (
                      <div
                        key={index}
                        className="flex flex-row w-full justify-between"
                      >
                        <div className="w-1/3 ">
                          <p className="text-[#606060]  font-roboto text-[14px] font-medium leading-normal mt-4 border-[#000]  px-4">
                            Portfolio description {index + 1}
                          </p>
                          <p className="text-[#000] font-roboto text-[16px] font-medium leading-normal mt-2 border-[#000]  px-4">
                            {item?.description
                              ? item?.description
                              : `${item?.description}`}
                          </p>
                        </div>

                        <div className="w-2/3 ">
                          <p className="text-[#606060]  font-roboto text-[16px] font-medium leading-normal mt-4 border-[#000]  px-4">
                            Images
                          </p>
                          <Carousel
                            opts={{
                              active: item?.images?.length > 3 ? true : false,
                              align: "start",
                            }}
                            className="w-full max-w-xs"
                          >
                            <CarouselContent>
                              {item?.images?.map((item: any, index: any) => (
                                <CarouselItem
                                  key={index}
                                  className=" md:basis-1/2 lg:basis-1/3"
                                >
                                  <img
                                    onClick={() => {
                                      handleSelected(item);
                                      setFullImg(true);
                                    }}
                                    src={item}
                                    alt="portfolioimage"
                                    className="w-[100px] h-[100px] rounded-md object-cover"
                                  />
                                </CarouselItem>
                              ))}
                            </CarouselContent>
                            {item?.images?.length > 3 && (
                              <>
                                <CarouselPrevious />
                                <CarouselNext />
                              </>
                            )}
                          </Carousel>
                        </div>
                      </div>
                    ))}
                  </TabsContent>
                ))}
              </Tabs>
            </div>
          </div>
          <div className="mx-auto flex flex-row  w-full justify-end mt-8 border-t">
            <div className="w-1/3 flex flex-col mx-auto  items-start pl-[10%]">
              <p className="text-[#000]  font-roboto text-lg font-medium leading-normal mt-4 border-[#000]  px-4">
                References
              </p>
              <p className="text-[#000]  font-roboto text-[12px] font-medium leading-normal mt-4 border-[#000]  px-4">
                contact in emergency situation
              </p>
            </div>

            <div className="flex flex-col flex-1  ">
              {viewProviderInReview?.contact?.map((item: any, index: any) => {
                return (
                  <div
                    key={index}
                    className="flex flex-row w-full justify-start flex-wrap border-b pb-4"
                  >
                    <div className="w-1/3 ">
                      <p className="text-[#606060]  font-roboto text-[16px] font-medium leading-normal mt-4 border-[#000]  px-4">
                        Full Name {index + 1}
                      </p>
                      <p className="text-[#000] font-roboto text-[16px] font-medium leading-normal mt-2 border-[#000]  px-4">
                        {item?.businessName
                          ? item?.businessName
                          : `${item?.fullName}`}
                      </p>
                    </div>

                    <div className="w-1/3 ">
                      <p className="text-[#606060]  font-roboto text-[16px] font-medium leading-normal mt-4 border-[#000]  px-4">
                        Relationship
                      </p>
                      <p className="text-[#000] font-roboto text-[16px] font-medium leading-normal mt-2 border-[#000]  px-4">
                        {item?.relationship ? item?.relationship : ""}
                      </p>
                    </div>
                    <div className="w-1/3 ">
                      <p className="text-[#606060]  font-roboto text-[16px] font-medium leading-normal mt-4 border-[#000]  px-4">
                        Address
                      </p>
                      <p className="text-[#000] font-roboto text-[16px] font-medium leading-normal mt-2 border-[#000]  px-4">
                        {item?.address ? item?.address : ""}
                      </p>
                    </div>
                    <div className="w-1/3 ">
                      <p className="text-[#606060]  font-roboto text-[16px] font-medium leading-normal mt-4 border-[#000]  px-4">
                        Email
                      </p>
                      <p className="text-[#000] font-roboto text-[16px] font-medium leading-normal mt-2 border-[#000]  px-4">
                        {item?.email ? item?.email : ""}
                      </p>
                    </div>
                    <div className="w-1/3 ">
                      <p className="text-[#606060]  font-roboto text-[16px] font-medium leading-normal mt-4 border-[#000]  px-4">
                        Phone Number
                      </p>
                      <p className="text-[#000] font-roboto text-[16px] font-medium leading-normal mt-2 border-[#000]  px-4">
                        {item?.phoneNumber ? item?.phoneNumber : ""}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="mx-auto flex flex-row  w-full justify-between mt-8 border-t">
            <div className="w-1/3 flex flex-col mx-auto  items-start pl-[10%]">
              <p className="text-[#000]  font-roboto text-lg font-medium leading-normal mt-4 border-[#000]  px-4">
                Verification
              </p>
              <p className="text-[#000]  font-roboto text-[12px] font-medium leading-normal mt-4 border-[#000]  px-4">
                Identity Verification
              </p>
            </div>
            <div className="flex flex-col flex-1 ">
              <div className="flex flex-row w-full justify-between">
                <div className="w-1/3 ">
                  <p className="text-[#606060]  font-roboto text-[13px] font-medium leading-normal mt-4 border-[#000]  px-4">
                    ID type
                  </p>
                  <p className="text-[#000] font-roboto text-[16px] font-medium leading-normal mt-2 border-[#000]  px-4">
                    {(identityRecord?.type || viewProviderInReview?.identity?.type)?.toUpperCase()}
                  </p>
                </div>
                <div className="w-1/3 mr-auto">
                  <p className="text-[#606060]  font-roboto text-[13px] font-medium leading-normal mt-4 border-[#000]  px-4">
                    ID Number
                  </p>
                  <p className="text-[#000] font-roboto text-[16px] font-medium leading-normal mt-2 border-[#000]  px-4">
                    {identityRecord?.number || viewProviderInReview?.identity?.number}
                  </p>
                </div>
                <div className="w-1/3 mr-auto">
                  <p className="text-[#000] font-roboto text-[16px] font-medium leading-normal mt-2 border-[#000]  px-4">
                    <span>ID status: {identityRecord?.status === 'approved' && identityRecord?.verificationExpiresAt && new Date(identityRecord.verificationExpiresAt).getTime() <= Date.now() ? 'expired' : identityRecord?.status || (viewProviderInReview?.isIdentityVerified ? 'approved' : 'not submitted')}</span>
                    {identityRecord?._id && <button className="block mt-3 text-purple-800 underline" onClick={handleNavigate}>Open ID check</button>}

                  </p>
                </div>
              </div>
            </div>
          </div>
          <NinReuseNotice evidence={identityRecord?.ninReuse} />
          <div className="mx-auto pl-[10%] w-full justify-between mt-8 border-t">
            <p className="text-[#000]  font-roboto text-[12px] font-medium leading-normal mt-4 border-[#000]  px-4">
              Live Test
            </p>
            <p className="text-[#000] font-roboto text-[16px] font-medium leading-normal mt-2 border-[#000]  px-4">
              {viewProviderInReview?.liveTest ? "True" : "False"}
            </p>
          </div>

          <p className="p-4">Profile verification and ID checks are separate. You can approve this profile before the ID check is approved. This does not approve their ID check.</p>
          {viewProviderInReview?.isVerified !== "approved" &&
            viewProviderInReview?.isVerified !== "rejected" && (
              <div className="flex flex-row mx-auto w-auto items-center mt-[7.5%] justify-center">
                <button
                  onClick={() => {
                    setOpen(true);
                  }}
                  className="bg-[#C9C9CB] py-3 text-white text-center text-shadow font-roboto text-lg font-medium leading-normal rounded-md w-1/2 lg:w-1/4 "
                >
                  Decline
                </button>
                <button
                  onClick={() => {
                    handleApprove("approved");
                  }}
                  disabled={loading}
                  className="disabled:bg-gray-600 bg-[#88087B] py-3 ml-8 text-white text-center text-shadow font-roboto text-lg font-medium leading-normal rounded-md w-1/2 lg:w-1/4 "
                >
                  Approve
                </button>
              </div>
            )}
        </main>
      </div>

      {loading && <Loader />}

      <Dialog open={open} handler={handleOpen}>
        <DialogBody>
          <div className="relative p-4 w-full  max-h-full flex  flex-col">
            <div className="p-4 md:p-5 text-center mx-auto w-[80%] space-y-6">
              <svg
                className="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 20"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                />
              </svg>
              <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                State reason for decline?
              </h3>
              <div>
                <TextEditor value={reason} setValue={setReason} />
                {/* <FroalaEditor
                  model={reason}
                  onModelChange={(e: string) => setReason(e)}
                  tag="textarea"
                  config={{
                    placeholderText: "Enter Reason Here!",
                    charCounterCount: false,
                    toolbarButtons: {
                      moreText: {
                        buttons: ["bold", "italic"],
                        align: "left",
                        buttonsVisible: 2,
                      },
                      moreParagraph: {
                        buttons: [
                          "formatOLSimple",
                          "alignRight",
                          "alignJustify",
                          "formatOL",
                          "formatUL",
                          "paragraphFormat",
                          "paragraphStyle",
                          "lineHeight",
                          "outdent",
                          "indent",
                          "quote",
                        ],
                        align: "left",
                        buttonsVisible: 3,
                      },
                    },
                  }}
                /> */}
              </div>
              <button
                data-modal-hide="popup-modal"
                type="button"
                disabled={loading || reason.trim().length < 1}
                className="text-white disabled:bg-gray-500 bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center me-2"
                onClick={() => {
                  handleApprove("rejected");
                }}
              >
                Decline
              </button>
              <button
                data-modal-hide="popup-modal"
                type="button"
                className="text-gray-500 ml-4 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                onClick={() => {
                  // close();
                  setOpen(false);
                }}
              >
                No, cancel
              </button>
              {/* {isLoading && (
                <>
                  <Dots size={40} color="var(--admin-accent)" />
                </>
              )} */}
            </div>
          </div>
        </DialogBody>
      </Dialog>
      <Dialog open={fullImg} handler={handleFullImg}>
        <DialogBody style={{ width: "100%", height: "80vh" }}>
          <div className="w-full h-full">
            <img src={selecetedImage} alt="" className="w-full h-full" />
          </div>
        </DialogBody>
      </Dialog>
    </>
  );
}
